import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mso-card"
}
const _hoisted_2 = { class: "mso-count" }
const _hoisted_3 = { class: "mso-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "mso-os-heading" }
const _hoisted_6 = { class: "mso-os-number" }
const _hoisted_7 = { class: "mso-os-desc" }
const _hoisted_8 = { class: "mso-os-item-count" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "mso-os-items"
}
const _hoisted_11 = { class: "mso-item-title" }
const _hoisted_12 = { class: "mso-item-meta" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "mso-item-row" }
const _hoisted_15 = { class: "mso-item-main" }
const _hoisted_16 = { class: "mso-item-title" }
const _hoisted_17 = { class: "mso-item-meta" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "mso-pagination"
}
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "mso-header",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.collapsed = !_ctx.collapsed))
        }, [
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["mso-chevron", { collapsed: _ctx.collapsed }]),
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5"
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
          ]))], 2)),
          _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "mso-title" }, "Minhas Ordens de Serviço", -1)),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.items.length), 1)
        ]),
        (!_ctx.collapsed)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedGroups, (group) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: group.key,
                    class: _normalizeClass(["mso-group", { 'mso-group--os': group.osTitle }])
                  }, [
                    (group.osTitle)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("button", {
                            class: "mso-os-header",
                            type: "button",
                            onClick: ($event: any) => (_ctx.toggleGroupOpen(group.key))
                          }, [
                            (_openBlock(), _createElementBlock("svg", {
                              class: _normalizeClass(["mso-chevron", { collapsed: !_ctx.openGroups.has(group.key) }]),
                              width: "13",
                              height: "13",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5"
                            }, [...(_cache[3] || (_cache[3] = [
                              _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
                            ]))], 2)),
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("span", _hoisted_6, "OS" + _toDisplayString(group.osNumber), 1),
                              _createElementVNode("span", _hoisted_7, _toDisplayString(group.osTitle), 1)
                            ]),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(group.items.length) + " " + _toDisplayString(group.items.length > 1 ? 'itens' : 'item'), 1),
                            _createElementVNode("span", {
                              class: "mso-btn mso-btn-primary mso-btn-complete",
                              onClick: _withModifiers(($event: any) => (_ctx.goComplete(group)), ["stop"])
                            }, "Completar", 8, _hoisted_9)
                          ], 8, _hoisted_4),
                          (_ctx.openGroups.has(group.key))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: item.id,
                                    class: "mso-item"
                                  }, [
                                    _createElementVNode("div", _hoisted_11, _toDisplayString(item.title), 1),
                                    _createElementVNode("div", _hoisted_12, [
                                      _createTextVNode(_toDisplayString(item.projectName) + " ", 1),
                                      (item.dueDate)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, " · prazo " + _toDisplayString(_ctx.formatDate(item.dueDate)), 1))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["mso-priority-badge", 'p-' + item.priority])
                                      }, _toDisplayString(_ctx.priorityLabel(item.priority)), 3)
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(group.items, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.id,
                            class: "mso-item"
                          }, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, _toDisplayString(item.title), 1),
                                _createElementVNode("div", _hoisted_17, [
                                  _createTextVNode(_toDisplayString(item.projectName) + " ", 1),
                                  (item.dueDate)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, " · prazo " + _toDisplayString(_ctx.formatDate(item.dueDate)), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["mso-priority-badge", 'p-' + item.priority])
                                  }, _toDisplayString(_ctx.priorityLabel(item.priority)), 3)
                                ])
                              ]),
                              _createElementVNode("button", {
                                class: "mso-btn",
                                type: "button",
                                onClick: ($event: any) => (_ctx.openMaintenance(item))
                              }, "Concluir", 8, _hoisted_19)
                            ])
                          ]))
                        }), 128))
                  ], 2))
                }), 128))
              ]),
              (_ctx.totalPages > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (p) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: p,
                        class: _normalizeClass(["mso-page-btn", { active: p === _ctx.currentPage }]),
                        type: "button",
                        onClick: ($event: any) => (_ctx.currentPage = p)
                      }, _toDisplayString(p), 11, _hoisted_21))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}